<template>
	<div class="public-mask">
		<div class="public-content">
			<div class="public-title">
				<span>{{entrust.caseNo}}</span>
				<i class="el-icon-close" @click="closeMask"></i>
			</div>
			<div class="public-box">
				<div class="public-item">
					<div class="public-item-title">
						委托人信息
					</div>
					<div class="public-item-area" v-loading="loading">
						<div class="public-unit">
							<div class="key">
								委托机构：
							</div>
							<div class="value">
								{{entrust.entrustmentOrganName}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系人：
							</div>
							<div class="value">
								{{entrust.contacts}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系方式：
							</div>
							<div class="value">
								{{entrust.phone}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								委托人：
							</div>
							<div class="value">
								{{entrust.entrustmentName}}
							</div>
						</div>
						<div class="public-unit-mid">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{entrust.address}}
							</div>
						</div>
						<div class="public-unit" v-if="userType==1">
							<div class="key">
								被鉴定人：
							</div>
							<div class="value">
								{{entrust.identifiedName}}
							</div>
						</div>
						<div class="public-unit-mid" v-if="userType==1">
							<div class="key">
								证件号码：
							</div>
							<div class="value">
								{{entrust.identifiedCertificateNo}}
							</div>
						</div>
						<div class="public-record" v-if="userType==1">
							<span v-if="entrust.appraisalRecordList.length==0">该鉴定人暂无鉴定记录</span>
							<div class="public-record-item" v-for="(item,index) in entrust.appraisalRecordList"
								:key="index">
								{{item}}
							</div>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						司法鉴定机构信息
					</div>
					<div class="public-item-area" v-loading="loading">
						<div class="public-unit">
							<div class="key">
								名称：
							</div>
							<div class="value">
								{{entrust.organization.organName}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								许可证号：
							</div>
							<div class="value">
								{{entrust.organization.licenceNo}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								邮政编码：
							</div>
							<div class="value">
								{{entrust.organization.postalCode}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{entrust.organization.address}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								机构负责人：
							</div>
							<div class="value">
								{{entrust.organization.leaderName}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系电话：
							</div>
							<div class="value">
								{{entrust.organization.phone}}
							</div>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						鉴定案件信息
					</div>
					<div class="public-item-area" v-loading="loading">
						<div class="public-unit-large">
							<div class="key">
								委托鉴定事项：
							</div>
							<div class="value">
								{{entrust.entrustedMattersName}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								补充事项：
							</div>
							<div class="value">
								{{entrust.supplement}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								是否重新鉴定：
							</div>
							<div class="value">
								{{entrust.identificationAgin==221?'是':'否'}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								委托鉴定用途：
							</div>
							<div class="value">
								{{entrust.purpose}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								委托鉴定要求：
							</div>
							<div class="value">
								{{entrust.requirement}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								检案摘要：
							</div>
							<div class="value">
								{{entrust.caseAbstract}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								提供鉴定材料目录和数量：
							</div>
							<div class="value">
								{{entrust.materialCatalogue}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								鉴定费用支付方式：
							</div>
							<div class="value">
								{{entrust.payTypeName}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								预计费用：
							</div>
							<div class="value">
								{{entrust.estimatedCost}} 元
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								签订文书发送方式：
							</div>
							<div class="value">
								{{entrust.sendTypeName}}
							</div>
						</div>
						<div class="public-unit-large" v-if="entrust.sendType!=208">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{entrust.sendAddress}}
							</div>
						</div>
					</div>
				</div>
				<div class="public-item" v-if="entrust.stopDocumentPath!='' && entrust.stopDocumentPath">
					<div class="public-item-title">
						终止鉴定信息
					</div>
					<div class="public-item-area" v-loading="loading">
						<div class="public-unit-large">
							<div class="key">
								终止文书：
							</div>
							<div class="value">
								<a :href="entrust.stopDocumentPath" target="_blank">
									{{entrust.stopDocumentName}}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'checked',
		props:['id','userType'],
		data() {
			return {
				entrust: {
					caseNo: '',
					entrustmentOrganName: '',
					contacts: '',
					entrustmentName: '',
					identifiedName: '',
					identifiedCertificateNo: '',
					appraisalRecordList: [],
					entrustedMattersName: '',
					supplement: '',
					identificationAgin: '',
					purpose: '',
					requirement: '',
					caseAbstract: '',
					materialCatalogue: '',
					payType: '',
					estimatedCost: '',
					payTypeName: '',
					organization: {
						organName: '',
						licenceNo: '',
						contacts: '',
						phone: '',
						email: '',
					},
				},
				loading:true
			};
		},
		methods: {
			closeMask() {
				this.$emit('closeChecked')
			},
			getData() {
				this.$api.findCaseInformationById({
					'id': this.id
				}, res => {
					this.entrust = res.data
					this.loading = false
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.getData();
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	@import url("../global.less");
</style>
